import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'officepartner',
} as IModuleProps;
